import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import FirebaseUILogin from './FirebaseUILogin'

const styles = {
    dialogTitle: {
      textAlign: 'center'
    }
}

const ResponsiveDialog = ({ classes, fullScreen, isLoginDialogOpen, toggleLoginDialog }) => { 
    return (
        <div>
            <Dialog
            fullScreen={fullScreen}
            open={isLoginDialogOpen}
            onClose={()=> toggleLoginDialog(false)}
            aria-labelledby="responsive-dialog-title"
            >
                <IconButton color="inherit" onClick={()=> toggleLoginDialog(false)} aria-label="Close">
                    <CloseIcon />
                </IconButton>
                <DialogTitle id="responsive-dialog-title" className={classes.dialogTitle}>{"請選擇以下任一方式登入或註冊"}</DialogTitle>
                <DialogContent>
                    <FirebaseUILogin />
                    {/* <DialogContentText></DialogContentText> */}
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default withMobileDialog()(withStyles(styles)(ResponsiveDialog));


// WEBPACK FOOTER //
// ./src/components/LoginDialog.js